module.exports = __webpack_public_path__ + "img/matumoto.35b8e81d.png";